import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVideoTrim: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"video-trim"} maskId="square-filled-radius-0-stroke-1-IconVideoTrim"><path fillRule="evenodd" clipRule="evenodd" d="M16 22H15V20H2V4H15V2H16V22ZM7 8.52841V15.4716L11.8602 12L7 8.52841Z" fill="currentColor"/><path d="M18 4H22V20H18V4Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconVideoTrim;
